/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'approversUserGroup';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'globalUserGroupApproverUser';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'approverUserGroup';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'approversUserGroup';

/** Default list sort — matches legacy `useManageApproverUserGroup`. */
export const DEFAULT_ORDER_BY = 'userGroup/name asc';
